// Lógica pura de derivação de KPIs/deep-link para a aba "Cadastros" do
// DashboardAdmin (VerificacoesContent). Extraída para função testável após
// o bug em que a regressão de uma migration fez babás pendentes "desaparecerem"
// do funil de aprovações — qualquer alteração futura na UI deve continuar
// passando pelos testes deste arquivo.

export const isBaba = (u) => u.tipo === "baba" || u.tipo === "babysitter";
export const isFamilia = (u) => u.tipo === "cliente" || u.tipo === "familia";

/**
 * Deriva { view, sub } a partir do initialTab (deep-link) recebido pelo
 * VerificacoesContent. Formatos aceitos: "babas-*", "familias-*", "aprovacoes"
 * ou ausência de valor (usa o estado padrão "overview"/"aprovacoes").
 */
export function parseInitialCadastrosTab(raw) {
  if (!raw) return { view: "overview", sub: "aprovacoes" };
  if (raw.startsWith("babas-")) return { view: "babas", sub: raw.replace("babas-", "") };
  if (raw.startsWith("familias-")) return { view: "familias", sub: raw.replace("familias-", "") };
  if (raw === "aprovacoes") return { view: "overview", sub: "aprovacoes" };
  return { view: "overview", sub: "todos" };
}

/**
 * Deriva os KPIs (ativos/pendentesDoc/incompletos/total) de babás e famílias
 * a partir dos resultados já carregados das RPCs usuarios_completos,
 * usuarios_para_aprovacao e usuarios_pendentes_detalhado.
 */
export function computeCadastrosKpi({
  registeredUsers,
  babasPendentes,
  familiasPendentes,
  incompleteUsers,
}) {
  const kpi = {
    babas: {
      ativos: (registeredUsers || []).filter(isBaba).length,
      pendentesDoc: (babasPendentes || []).length,
      incompletos: (incompleteUsers || []).filter(
        (u) => isBaba(u) && u.pendencias?.babas?.length > 0
      ).length,
    },
    familias: {
      ativos: (registeredUsers || []).filter(isFamilia).length,
      pendentesDoc: (familiasPendentes || []).length,
      incompletos: (incompleteUsers || []).filter(
        (u) => isFamilia(u) && u.pendencias?.clientes?.length > 0
      ).length,
    },
  };
  kpi.babas.total = kpi.babas.ativos + kpi.babas.pendentesDoc + kpi.babas.incompletos;
  kpi.familias.total =
    kpi.familias.ativos + kpi.familias.pendentesDoc + kpi.familias.incompletos;
  return kpi;
}
